import {
	GET_SAVED_CARDS_REQUEST,
	GET_SAVED_CARDS_SUCCESS,
	GET_SAVED_CARDS_ERROR,
	GET_SAVED_CARD_TOKEN_REQUEST,
	GET_SAVED_CARD_TOKEN_SUCCESS,
	GET_SAVED_CARD_TOKEN_ERROR
} from 'actions/MyAccountActions/SavedCardActions';
import { combineReducers } from 'redux';
import { INIT } from 'utils/asyncStatusHelper';
import { createReducer } from 'utils/reducerUtils';

const defaultState = {
	asyncStatus: INIT
};

export const savedCards = createReducer(
	GET_SAVED_CARDS_REQUEST,
	GET_SAVED_CARDS_SUCCESS,
	GET_SAVED_CARDS_ERROR,
	defaultState
);

export const savedCardToken = createReducer(
	GET_SAVED_CARD_TOKEN_REQUEST,
	GET_SAVED_CARD_TOKEN_SUCCESS,
	GET_SAVED_CARD_TOKEN_ERROR,
	defaultState
);

export default combineReducers({
	savedCards,
	savedCardToken
});
